import { useContext } from 'react';
import { LocaleContext } from '../contexts/localeContext.js';
export const useLocale = () => {
    return useContext(LocaleContext);
};
